import React, { useState } from 'react';
import './ProductOptionsModal.css';

const XIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);
const InfoIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
        <circle cx="12" cy="12" r="10" /><line x1="12" y1="11" x2="12" y2="16" /><line x1="12" y1="8" x2="12" y2="8" />
    </svg>
);
const CheckIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);
const toInitials = (n = '') =>
    n.trim().split(/\s+/).slice(0, 2).map((w) => w[0] || '').join('').toUpperCase() || 'SP';

/**
 * ProductOptionsModal — diseño del POS Smart Pay (v64) acoplado a tu lógica actual.
 * Todos los datos y funciones se reciben por props: la lógica sigue viviendo en tu componente.
 */
export function ProductOptionsModal({
    // visibilidad
    show,
    onBackdropClick,          // handleClose
    onClose,                  // () => (setShowModalSelectItem(false), setPreviewSegment([]), setComboSelect([]), setActiveTab(0), clearDataInfoProduct(true))
    // producto
    selectProduct,
    buildCloudinaryImageUrl,
    img_default,
    // paso 1: segmentos
    segments = [],
    contentSegments,          // función que renderiza tus segmentos
    EmptyComponent,           // tu componente <Empty />
    // combos
    activeTab,
    changeTab,
    comboSelect = [],
    actionCheckIngradent,
    getdataGroup,
    deleteSetGroupOfComboSelected,
    setActiveTab,
    formatModifierPrice,
    getModifierPrice,
    // paso 2: cantidad y notas
    number,
    incrementNumber,
    decrementNumber,
    setNotesItem,
    // navegación
    step,
    totalSteps,
    nextStep,
    prevStep,
    onAddToCart,              // e => (setShowModalSelectItem(false), setShow(false), addProduct(e))
    className = '',
}) {
    const [imgFailed, setImgFailed] = useState(false);
    if (!show) return null;

    const p = selectProduct || {};
    const imgUrl = buildCloudinaryImageUrl
        ? (buildCloudinaryImageUrl({ url: p.img, width: 300, quality: 'auto', type: 'image' }) || img_default)
        : (p.img || img_default);
    const showImg = imgUrl && !imgFailed;
    const isCombo = !!p.combo_id;
    const setGroups = p.setGroups || [];
    const currentSet = setGroups[activeTab];


    return (
        <div className="pp-overlay open" onClick={onBackdropClick}>
            <div
                className={`pp-modal ${isCombo ? 'wide' : ''} ${className}`.trim()}
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                {/* ===== Header ===== */}
                <div className="pp-head">
                    {showImg
                        ? <img className="pp-thumb"
                            src={imgUrl}
                            alt={p.name}
                            onError={() => setImgFailed(true)} />
                        : <div className="pp-thumb-ph">{toInitials(p.name)}</div>}
                    <div className="pp-headinfo">
                        <div className="pp-title">{p.name}</div>
                        {p.description && <div className="pp-sub">{p.description}</div>}
                        {p.favorite == 1 && (
                            <span className="pp-fav"><i className="uil uil-star"></i> Favorito</span>
                        )}
                    </div>
                    <button className="pp-x" onClick={onClose} aria-label="Cerrar">{XIcon}</button>
                </div>

                {/* ===== Pasos ===== */}
                <div className="pp-dots">
                    <span className={`pp-dot ${step === 1 ? 'on' : ''}`}><span className="n">1</span>Opciones</span>
                    <span className="pp-ln" />
                    <span className={`pp-dot ${step === 2 ? 'on' : ''}`}><span className="n">2</span>Cantidad</span>
                </div>

                {/* ===== Body ===== */}
                <div className="pp-body  ">
                    {/* ---- Paso 1 ---- */}
                    <div className={`pp-step border-start border-end border-light rounded-3 ${step === 1 ? 'is-active' : ''}`}>
                        {segments.length > 0 ? (
                            <div className="pp-group">
                                <div className="pp-glabel">
                                    Opciones del producto 
                                    {/* <span className="pp-ghint">{InfoIcon}Elige tus preferencias</span> */}
                                </div>

                                <div className="pp-segments"> {contentSegments && contentSegments()} </div>





                            </div>
                        ) : (
                            EmptyComponent || (
                                <div className="pp-empty">
                                    <div className="pp-empty__ic">😢</div>
                                    <div className="pp-empty__t">Sin opciones disponibles</div>
                                    <div className="pp-empty__s">Este producto no cuenta con opciones disponibles por el momento.</div>
                                </div>
                            )
                        )}

                        {/* ---- Combos ---- */}
                        {isCombo && (
                            <div className="pp-combo">
                                <div className="pp-glabel">
                                    Pasos del combo
                                    <span className="pp-ghint">{InfoIcon}Completa cada grupo</span>
                                </div>

                                <div className="pp-tabs">
                                    {setGroups.map((setGroup, index) => (
                                        <button
                                            key={index}
                                            className={`pp-tab ${setGroup.ready == true ? 'is-ready' : ''} ${index === activeTab ? 'is-active' : ''}`}
                                            onClick={() => changeTab(index)}
                                            type="button"
                                        >
                                            {setGroup.name}
                                            {setGroup.ready == true && <i className="uil uil-check-circle"></i>}
                                        </button>
                                    ))}
                                </div>

                                {currentSet && (
                                    <>
                                        <div className="pp-setname">{currentSet.name}</div>
                                        <div className="pp-list">
                                            {currentSet.groups.map((group) => (
                                                <button
                                                    key={group.group_id}
                                                    type="button"
                                                    className="pp-opt"
                                                    onClick={() => actionCheckIngradent(group, 'setGroup' + currentSet.set_id + group.group_id, true)}
                                                >
                                                    <input
                                                        className="pp-opt__native"
                                                        type={currentSet.count > 1 ? 'checkbox' : 'radio'}
                                                        name={'setGroup' + currentSet.set_id}
                                                        id={'setGroup' + currentSet.set_id + group.group_id}
                                                        value=""
                                                        checked={false}
                                                        readOnly
                                                    />
                                                    <span className="pp-othumb">
                                                        <img
                                                            src={buildCloudinaryImageUrl
                                                                ? (buildCloudinaryImageUrl({ url: group.img, width: 300, quality: 'auto', type: 'image' }) || img_default)
                                                                : (group.img || img_default)}
                                                            alt={group.name}
                                                        />
                                                    </span>
                                                    <span className="pp-tick">{CheckIcon}</span>
                                                    <span className="pp-oname">{group.name}</span>
                                                    {group.description && <span className="pp-odesc">{group.description}</span>}
                                                    <span className="pp-oprice">{formatModifierPrice(group.price)}</span>
                                                </button>
                                            ))}
                                        </div>
                                    </>
                                )}

                                {/* Resumen del combo */}
                                {comboSelect.length > 0 && (
                                    <div className="pp-summary">
                                        <div className="pp-glabel">Resumen del combo</div>
                                        <div className="pp-list">
                                            {comboSelect.map((setGroup, si) => (
                                                setGroup.groupsselected.map((group, index) => (
                                                    <div className="pp-opt on pp-opt--summary" key={`${si}-${index}`}>
                                                        <span className="pp-othumb">
                                                            <img
                                                                src={buildCloudinaryImageUrl
                                                                    ? (buildCloudinaryImageUrl({ url: group.img, width: 300, quality: 'auto', type: 'image' }) || img_default)
                                                                    : (group.img || img_default)}
                                                                alt={group.name}
                                                            />
                                                        </span>
                                                        <span className="pp-oname">{setGroup.name}: {group.name}</span>
                                                        {group.description && <span className="pp-odesc">{group.description}</span>}

                                                        {group.segments && group.segments.length > 0 && (
                                                            <details className="pp-details">
                                                                <summary className="pp-details__sum">Detalles</summary>
                                                                <div className="pp-details__body">
                                                                    {group.segments.map((item, ix) => (
                                                                        <div className="pp-details__row" key={ix}>
                                                                            <span>{item.segment_name}: <strong>{item.name}</strong></span>
                                                                            <span className="pp-details__pr">{getModifierPrice(item.price).toFixed(2)}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </details>
                                                        )}

                                                        <div className="pp-sumfoot">
                                                            <span className="pp-oprice">{formatModifierPrice(group.price)}</span>
                                                            <span className="pp-sumacts">
                                                                <button
                                                                    className="pp-iconbtn"
                                                                    title="Modificar Producto"
                                                                    data-id={index}
                                                                    onClick={() => (setActiveTab(setGroup.activeTab), getdataGroup(group, false, true))}
                                                                    type="button"
                                                                >
                                                                    <i className="uil uil-edit"></i>
                                                                </button>
                                                                <button
                                                                    className="pp-iconbtn pp-iconbtn--danger"
                                                                    title="Eliminar Producto"
                                                                    data-id={index}
                                                                    onClick={() => deleteSetGroupOfComboSelected(setGroup.activeTab)}
                                                                    type="button"
                                                                >
                                                                    <i className="uil uil-trash-alt"></i>
                                                                </button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ---- Paso 2 ---- */}
                    <div className={`pp-step ${step === 2 ? 'is-active' : ''}`}>
                        <div className="pp-step2">
                            <div className="pp-field">
                                <span className="fl">Cantidad</span>
                                <div className="pp-qty">
                                    <button className="pp-qbtn" onClick={() => decrementNumber()} disabled={number <= 1} type="button">−</button>
                                    <input
                                        type="number"
                                        min={1}
                                        value={number}
                                        className="pp-qn pp-qinput"
                                        onChange={(e) => incrementNumber(parseInt(e.target.value))}
                                    />
                                    <button className="pp-qbtn" onClick={() => incrementNumber()} type="button">+</button>
                                </div>
                            </div>

                            <div className="pp-field">
                                <span className="fl">Notas <span className="opt">(opcional)</span></span>
                                <textarea
                                    className="pp-notes"
                                    placeholder="Escribir..."
                                    rows="3"
                                    maxLength={200}
                                    onChange={(e) => setNotesItem(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* ===== Footer Steps (hidden-frame-pos) ===== */}
                <div className="pp-foot ">
                    {step === 1 && (
                        <>
                            <button className="pp-btn ghost" onClick={onClose} type="button" disabled={step === totalSteps}>
                                Cerrar
                            </button>
                            <button className="pp-btn primary" onClick={nextStep} type="button" disabled={step === totalSteps}>
                                Siguiente
                            </button>
                        </>
                    )}
                    {step !== 1 && (
                        <>
                            <button className="pp-btn ghost" onClick={prevStep} disabled={step === 1} type="button">
                                Regresar
                            </button>
                            <button className="pp-btn primary " onClick={onAddToCart} disabled={step === 1} type="button">
                                Agregar al carrito
                            </button>
                        </>
                    )}
                </div>

                {/* ===== Footer  (display-frame-pos) ===== */}
                {/* <div className="pp-foot display-frame-pos">
          <button className="pp-btn ghost" onClick={onClose} type="button" disabled={step === totalSteps}>
            Cerrar
          </button>
          <button className="pp-btn primary" onClick={onAddToCart} type="button">
            Agregar al carrito
          </button>
        </div>  */}
            </div>
        </div>
    );
}

export default ProductOptionsModal;